// Not importing Openseadragon into the bundle, use global var instead
export const $ = OpenSeadragon;

export const DIRECTION_HORIZONTAL = Symbol('horizontal');
export const DIRECTION_VERTICAL = Symbol('vertical');



// WEBPACK FOOTER //
// ./src/globals.js